import { jsx as _jsx } from "preact/jsx-runtime";
import { useEffect } from 'preact/hooks';
import { usePageHeader } from '@/hooks/usePageHeader';
import { KnowledgeBasePanel } from './KnowledgeBasePanel';
import { KnowledgeBaseLevel } from '@/types/knowledgeBase';
export function KnowledgeBasePage({ clientCompanyId, workspaceId }) {
    const { setHeader } = usePageHeader();
    useEffect(() => {
        setHeader({ items: [{ text: 'Knowledge Base' }] });
    }, []);
    return (_jsx("div", { className: "p-6", children: _jsx(KnowledgeBasePanel, { clientCompanyId: clientCompanyId, workspaceId: workspaceId, level: KnowledgeBaseLevel.Workspace }) }));
}
